import React, { useState } from "react";
import {
  CustomTextField,
  CustomSelectField,
} from "../../../../../../partials/content/Forms";
import {
  FormDateField,
  FormTextField,
} from "../../../../../../partials/content/Forms/FormField";
import { InputAdornment, IconButton, DialogActions } from "@material-ui/core";
import { Search } from "@mui/icons-material";
import DialogLayout from "../../../../../../partials/content/DialogLayout";
import SearchCurrency from "../../../../setup/finance/searchCurrency";
const ItemsTransferHead = ({
  onBlur,
  onChange,
  values,
  touched,
  errors,
  setFieldValue,
  onOpenSearchToLocation,
}) => {
  const [openSearchCurrency, setOpenSearchCurrency] = useState(false);

  return (
    <React.Fragment>
      <div className="row">
        <div className="col-sm-6 col-md-6 col-lg-6">
          <FormDateField label="Movement Date" name="moveDate" />
          <CustomSelectField
            label="Destination Type"
            propertyName="transferToType"
            onBlur={onBlur}
            onChange={(e) => {
              setFieldValue("toLocationID", 0);
              setFieldValue("toLocationName", "");
              setFieldValue("itemsTransfer", []);
              onChange(e);
            }}
            values={values}
            touched={touched}
            errors={errors}
            size="small"
            options={[
              { value: 1, label: "Warehouse" },
              { value: 2, label: "Outlet" },
            ]}
          />
          <div className="row">
            <div className="col-sm-6 col-md-6 col-lg-6">
              <FormTextField
                label="Source Location"
                name="fromLocationName"
                readonly
              />
            </div>
            <div className="col-sm-6 col-md-6 col-lg-6">
              <FormTextField
                label="Destination Location"
                name="toLocationName"
                searchButton
                readonly
                onSearchClick={onOpenSearchToLocation}
              />
            </div>
          </div>
        </div>
        <div className="col-sm-6 col-md-6 col-lg-6">
          <FormTextField
            label="Currency"
            name="currencyCode"
            searchButton
            readonly
            onSearchClick={() => {
              setOpenSearchCurrency(true);
            }}
          />
          <FormTextField
            label="Transfer Cost"
            name="totalCost"
            readonly
            currencyField
            currencyCode={values.currencyCode}
          />
        </div>
      </div>
      <DialogLayout
        open={openSearchCurrency}
        title="Search Currency"
        onCloseDialog={() => {
          setOpenSearchCurrency(false);
        }}
        maxWIdth="sm"
      >
        <SearchCurrency
          onSelectCurrency={(currency) => {
            setFieldValue("currencyID", currency.ID);
            setFieldValue("currencyCode", currency.currencyCode);
            setOpenSearchCurrency(false);
          }}
        />
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenSearchCurrency(false);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
    </React.Fragment>
  );
};

export default ItemsTransferHead;
